// export const MAIN_API = "https://api.stepoutplay.com/api/";
// export const SSENSE_URL = "https://api-sense.stepoutplay.com/sense/";

export const MAIN_API = "https://api-main-beta-new.stepoutplay.com/api/";
export const SSENSE_URL = "https://api-sense-beta-new.stepoutplay.com/sense/";


// export const MAIN_API = process.env.REACT_APP_MAIN_API_URL;
// export const SSENSE_URL = process.env.REACT_APP_SENSE_API_URL;

// export const MAIN_API = "http://localhost:8000/api/";
// export const SSENSE_URL = "http://localhost:8001/sense/";
